import { useStateContainer } from '@state-containers/react';
import { CalendarState } from '../state/CalendarState';

export const useCalendar = () => {
  return useStateContainer(CalendarState);
};
